export const selectNext = (index, arr) => {
  const res =
    arr[
      arr.length - (index % arr.length) === arr.length
        ? 0
        : arr.length - (index % arr.length)
    ];
  return res;
};
export const randomArr = (arr) => {
  const res = arr[Math.floor(Math.random() * arr.length)];
  return res;
};
export const chooseArrTpe = (source, displayMode, dia, gridSize, x, y, wave_index = 0) => {
  let generatedArr = dia > gridSize / 3 ? randomArr(source) : source[0];
  if (displayMode === "wave") {
    generatedArr = selectNext(x + y + Math.floor(wave_index), source);
  } else if (displayMode === "fixed") {
    generatedArr = selectNext(x, source);
  }
  return generatedArr;
};
